<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="singpause">
            <h2>
                SingPause
                <b-button :size="size" @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                busyText="Lädt SingPause Daten..."
                emptyText="Keine SingPause Daten gefunden"
            ></Table>
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";

const StatusApi = ApiFactory.get("status");

export default {
    name: "SingPause",
    mixins: [CommonView, Size],
    components: {
        MainContainer,
        Table
    },
    data() {
        return {
            fields: [
                {
                    key: "value",
                    label: "Status",
                    sortable: true
                },
                {
                    key: "name",
                    label: "Bezeichnung",
                    sortable: true
                },
                {
                    key: "singer",
                    label: "Sänger*Innen",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: [
                {
                    key: "value",
                    label: "Status",
                    type: "text"
                },
                {
                    key: "name",
                    label: "Bezeichnung",
                    type: "text"
                },
                {
                    key: "singer",
                    label: "Sänger*Innen",
                    type: "checkbox",
                    checked_value: 1,
                    unchecked_value: 0,
                    description:
                        "Enthält dieser Status potentielle Sänger*Innen für kommende Werke?"
                }
            ],
            api: StatusApi
        };
    },
    watch: {},
    methods: {}
};
</script>
